import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
    hasDropdownLoaded: false,
    serviceTypeList: Custom.serviceTypeList,
    admissionTypeList: Custom.admissionTypeList,
    serviceOfficerComentList: Custom.serviceOfficerComentList,
    outExpenseList: Custom.outExpenseList,
    referList: Custom.referList,
    bankInfoList: [],
    branchInfoList: [],
    hospitalInfoList: [],
    hospitalThirtyPercentList: [],
    serviceInfoList: [],
    deptList: [],
    consultancyReportTypeList: Custom.consultancyReportTypeList,
    importTypeList: Custom.importTypeList,
    hosAssignDepartmentList: [],
    deliTypList: Custom.deliTypList,
    kindsDeliTypList: Custom.kindsDeliTypList,
    amountFmList: Custom.amountFmList,
    payModeList: Custom.payModeList,
    mobileBankingList: Custom.mobileBankingList,
    bloodGroupList: Custom.bloodGroupList,
    itemCatList: [],
    hosItemList: [],
    hosItemStockList: [],
    disabilityTypesList: [],
    centerTypeList: Custom.centerTypeList,
    hospitalCategoryList: Custom.hospitalCategoryList,
    hospitalClassList: Custom.hospitalClassList,
    pMdList: Custom.pMdList,
    subServiceTypeList: Custom.subServiceTypeList,
    memberTypeList: Custom.memberTypeList,
    masterServiceInfoList: [],
    patientTypeList: Custom.patientTypeList,
    burnPatientTypeList: Custom.burnPatientTypeList,
    donationTypeList: Custom.donationTypeList,
    donationTypeForList: Custom.donationTypeForList,
    accountTypeList: Custom.accountTypeList,
    hosBankAccountInfoList: [],
    depositTypeList: Custom.depositTypeList,
    itemCategoryList: [],
    socialServiceDeliveryList: Custom.socialServiceDeliveryList,
    rehabilitationInstituteList: Custom.rehabilitationInstituteList,
    hosWardList: [],
    hosBedList: [],
    identityTypeList: Custom.identityTypeList,
    reportDurationList: Custom.reportDurationList,
    progressReportTypeList: Custom.progressReportTypeList,
    socialServiceCategoryList: Custom.socialServiceCategoryList,
    socialServiceNameList: Custom.socialServiceNameList,
    therapyCenterList: [],
    campaignCenterList: [],
    campaignList: [],
    therapyCentersList: [],
    patientDisabilityType: Custom.patientDisabilityType,
    campaignDesignationList: [],
    assistiveDeviceList: [],
    ccList: [],
    hpcList: [],
    rxList: [],
    dhList: [],
    oeList: [],
    pmhList: [],
    adviceList: [],
    diagnosisList: [],
    therapyServiceList: [],
    educationalQualificationList: Custom.educationalQualificationList,
    occupationList: Custom.occupationList,
    typeHouseList: Custom.typeHouseList,
    monthlyIncomeList: Custom.monthlyIncomeList,
    iDInformationList: Custom.iDInformationList,
    patientList: [],
    subCenterList: [],
    driverList: [],
    dcpoolList: [],
    vanInfoList: [],
    applicationStatusList: Custom.applicationStatusList,
    disabilityInformationList: Custom.disabilityInformationList,
    scheduleDurationTypeList: Custom.scheduleDurationTypeList,
    patientStatusList: Custom.patientStatusList,
    vanConditionlist: Custom.vanConditionlist,
    equipmentTypeList: Custom.equipmentTypeList,
    reasonList: Custom.reasonList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
